import { render, staticRenderFns } from "./SpreadMessagePc.vue?vue&type=template&id=e648a3b2&"
import script from "./SpreadMessagePc.vue?vue&type=script&lang=js&"
export * from "./SpreadMessagePc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports